module.exports = __webpack_public_path__ + "static/media/tasks-alt.0bdf0106.svg";